import { useEffect, useState } from "react";
import axios from "axios";
import { YoutubeLogo, FacebookLogo, InstagramLogo, TiktokLogo, WhatsappLogo, SpotifyLogo } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NETWORKS = [
  { key: "youtube", icon: YoutubeLogo, id: "footer-youtube", label: "YouTube", fallback: "https://www.youtube.com/@vientodegracia9235" },
  { key: "instagram", icon: InstagramLogo, id: "footer-instagram", label: "Instagram", fallback: "" },
  { key: "facebook", icon: FacebookLogo, id: "footer-facebook", label: "Facebook", fallback: "" },
  { key: "tiktok", icon: TiktokLogo, id: "footer-tiktok", label: "TikTok", fallback: "" },
  { key: "spotify", icon: SpotifyLogo, id: "footer-spotify", label: "Spotify", fallback: "" },
];

const Footer = () => {
  const [socials, setSocials] = useState({});

  useEffect(() => {
    axios
      .get(`${API}/settings`)
      .then(({ data }) => setSocials(data.socials || {}))
      .catch(() => {});
  }, []);

  const links = [
    ...NETWORKS.map((n) => ({ ...n, href: socials[n.key] || n.fallback })),
    { key: "whatsapp", icon: WhatsappLogo, id: "footer-whatsapp", label: "WhatsApp", href: "https://wa.me/527223947826" },
  ];

  return (
  <footer className="border-t border-white/10 bg-ink pb-10 pt-20" data-testid="main-footer">
    <div className="mx-auto max-w-[1600px] px-6 lg:px-12">
      <img src="/logo-mark-oficial.png" alt="Logo oficial Viento de Gracia" className="mb-10 h-20 w-20 object-contain" data-testid="footer-logo" />
      <p className="font-serif text-[10vw] leading-[0.85] tracking-tight text-paper/95 lg:text-[7vw]" data-testid="footer-brand">
        Viento de <em className="italic text-gold">Gracia</em>
      </p>

      <div className="mt-16 grid gap-12 border-t border-white/10 pt-12 md:grid-cols-3">
        <div>
          <p className="text-[10px] font-light uppercase tracking-[0.4em] text-fire">Palabra</p>
          <p className="mt-4 max-w-xs text-sm font-light leading-relaxed tracking-wide text-smoke">
            «Porque por gracia sois salvos por medio de la fe; y esto no de vosotros, pues es don de Dios.»
            — Efesios 2:8
          </p>
        </div>

        <div>
          <p className="text-[10px] font-light uppercase tracking-[0.4em] text-fire">Visítanos</p>
          <p className="mt-4 text-sm font-light leading-relaxed tracking-wide text-smoke" data-testid="footer-address">
            Laguna de las Palomas 304<br />
            Nueva Oxtotitlán, 50100<br />
            Toluca de Lerdo, Estado de México
          </p>
        </div>

        <div>
          <p className="text-[10px] font-light uppercase tracking-[0.4em] text-fire">Síguenos</p>
          <div className="mt-4 flex gap-px border border-white/15" data-testid="footer-socials">
            {links.map((s) =>
              s.href ? (
                <a
                  key={s.id}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  data-testid={s.id}
                  className="flex h-12 w-12 items-center justify-center border-r border-white/15 text-paper/60 transition-colors duration-300 last:border-r-0 hover:bg-paper hover:text-ink"
                >
                  <s.icon size={19} weight="light" />
                </a>
              ) : (
                <span
                  key={s.id}
                  aria-label={`${s.label} (próximamente)`}
                  data-testid={s.id}
                  className="flex h-12 w-12 cursor-default items-center justify-center border-r border-white/15 text-paper/20 last:border-r-0"
                >
                  <s.icon size={19} weight="light" />
                </span>
              )
            )}
          </div>
        </div>
      </div>

      <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-[10px] font-light uppercase tracking-[0.25em] text-paper/30 sm:flex-row sm:items-center">
        <p data-testid="footer-domain">vientodegracia.com · Iglesia Cristiana Viento de Gracia</p>
        <p>Toluca, Estado de México · {new Date().getFullYear()}</p>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
